module.exports = __webpack_public_path__ + "static/xd-bc5229e06917265d575b3cae21d79f9c.png";